// extracted by mini-css-extract-plugin
export default {"main":"AccountPage_main__Vki2h","content":"AccountPage_content__M2NGv","sidebar":"AccountPage_sidebar__DX3bP"};